import { SelectedMenu } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import autoFillLegs from 'rangeConfig/besta/behaviors/autoFillLegs';
import autoFillLegsWithSupport from 'rangeConfig/besta/behaviors/autoFillLegsWithSupport';
import replaceWithDefaultLegs from 'rangeConfig/besta/behaviors/replaceWithDefaultLegs';
import { supportLegSelection } from 'rangeConfig/besta/selection';
import { hideSupportLegsMenu } from 'rangeConfig/besta/rules/hideMenuRules';
import { supportLegs } from 'rangeConfig/besta/filters/selectedMenuProductFilters';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeLegs',
  behaviors: {
    productDeleted: [replaceWithDefaultLegs]
  },
  content: [
    {
      id: 'legs-selected-menu-legs',
      title: 'storageone.productListLegsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText communicatedSizeText',
      behaviors: {
        productClicked: [autoFillLegs],
        productDropped: [autoFillLegs]
      },
      productTypes: [ProductType.BESTA_DEFAULT_LEG, ProductType.BESTA_LEG],
      productFilters: []
    },
    {
      id: 'legs-selected-menu-support-legs',
      title: 'storageone.productListSupportLegsTitle',
      cardsTitle: 'name',
      behaviors: {
        productClicked: [autoFillLegsWithSupport],
        productDropped: [autoFillLegsWithSupport]
      },
      productTypes: [ProductType.BESTA_LEG, ProductType.BESTA_SUPPORTING_LEG],
      hidden: hideSupportLegsMenu,
      overrideSelection: supportLegSelection,
      productFilters: [supportLegs]
    }
  ]
};

export default selectedMenu;
